import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { removeToken } from "../../utils/auth";

export default function Navbar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    navigate("/login");
  };

  return (
    <nav style={{ background: "linear-gradient(90deg, #0a0a0a 0%, #181818 50%, #0a0a0a 100%)", borderBottom: "1px solid rgba(200,150,12,0.3)" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">

          <Link to="/" className="flex items-center gap-3">
            <img src="/makalu-logo.svg" alt="Makalu" className="h-10 w-auto" />
            <div className="hidden sm:block">
              <p className="text-xs tracking-widest" style={{ color: "#C8960C", fontFamily: "serif" }}>MAKALU AGRO AND TRADE</p>
            </div>
          </Link>

          <div className="flex items-center gap-1">
            {[{ to: "/", label: "Dashboard" }, { to: "/add", label: "Add Product" }, { to: "/edit-photo", label: "Edit Photo" }, { to: "/add-mukhi", label: "Add Mukhi" }, { to: "/auto-mukhi", label: "Auto Mukhi" }].map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200"
                style={pathname === l.to
                  ? { background: "rgba(200,150,12,0.15)", color: "#FFD700", border: "1px solid rgba(200,150,12,0.4)" }
                  : { color: "#8A6000", border: "1px solid transparent" }
                }
                onMouseEnter={e => { if (pathname !== l.to) { e.target.style.color = "#C8960C"; } }}
                onMouseLeave={e => { if (pathname !== l.to) { e.target.style.color = "#8A6000"; } }}
              >
                {l.label}
              </Link>
            ))}
            <a
              href={process.env.REACT_APP_AVRL_URL || "http://localhost:5001/avrl/"}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200"
              style={{ color: "#4a90d9", border: "1px solid rgba(44,90,160,0.4)", background: "rgba(44,90,160,0.08)" }}
              onMouseEnter={e => { e.currentTarget.style.background = "rgba(44,90,160,0.2)"; e.currentTarget.style.color = "#7ab8f5"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "rgba(44,90,160,0.08)"; e.currentTarget.style.color = "#4a90d9"; }}
            >
              AVRL ↗
            </a>
            <button
              onClick={handleLogout}
              className="px-3 py-2 rounded-lg text-sm font-medium ml-2"
              style={{ color: "#7f1d1d", border: "1px solid rgba(127,29,29,0.4)", background: "rgba(127,29,29,0.08)", cursor: "pointer" }}
              onMouseEnter={e => { e.currentTarget.style.background = "rgba(127,29,29,0.2)"; e.currentTarget.style.color = "#fca5a5"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "rgba(127,29,29,0.08)"; e.currentTarget.style.color = "#7f1d1d"; }}
            >
              Logout
            </button>
          </div>

        </div>
      </div>
      <div className="gold-divider" />
    </nav>
  );
}
